import Store from '@/store/store';

export class SignatureDocxData {
    constructor(obj = {}) {
        const appSigningSettings = Store.getters.appSigningSettings || {};

        this.contents = obj.contents; // Base64 file content
        this.thumbprint = obj.thumbprint || '' // Ако съществува няма да изискава избор на сертификат, а ще го намери в store-а
        this.options = obj.options || {};

        if (!this.options.hasOwnProperty('name')) {
            this.options.name = appSigningSettings.defaultDocxName || '';
        }

        if (!this.options.hasOwnProperty('title')) {
            this.options.title = appSigningSettings.defaultDocxTitle || '';
        }

        if (!this.options.hasOwnProperty('email')) {
            this.options.email = appSigningSettings.defaultDocxEmail || '';
        }
    }
}
